import { ClientError } from '../ClientError';
import { GQLPlugin } from '../GQLTypes';

export const ErrorNotifierPlugin: GQLPlugin = ({ onClientError }, { onErrorCallback }) => {
  onClientError.push(error => {
    if (error instanceof ClientError) {
      const { response } = error;

      if (response.error) {
        onErrorCallback({
          message: response.error,
        });
      }

      if (response.errors) {
        response.errors.forEach(({ message }) => {
          onErrorCallback({
            message,
          });
        });
      }
    }
    throw error;
  });
};
